<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="CONTRACT PRICING" >
          <template slot="actions">
            <vs-button v-can="'download-customers-contract-price-data'" @click.stop="onClickDownloadSheet" class="mr-4 mb-4" color="warning" type="border" id="contract-pricing-download-button">
                Download Pricing List
              </vs-button>
            <vs-button v-can="'create-edit-product-contract'" @click="onClickCreateSite" class="mr-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input v-can="'view-product-contract'" icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="product_contract_table" v-can="'view-product-contract'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="20%">FG PRODUCTS</vs-th>
                <vs-th width="20%">PRODUCT NAMES</vs-th>
                <vs-th width="10%" sort-key="start_timestamp">START DATE</vs-th>
                <vs-th width="10%" sort-key="expiry_timestamp">EXPIRE DATE</vs-th>
                <vs-th width="10%" sort-key="contract_product_code">CONTRACTS PRODUCT CODE</vs-th>
                <vs-th width="15%" sort-key="note">NOTE</vs-th>
                <vs-th width="10%" >STATUS</vs-th>
                <vs-th width="10%" v-can="'create-edit-product-contract'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].items">
                    <span v-if="data[indextr].items.length > 0" v-for="(item, item_idx) in data[indextr].items" :key="item.formulation_code">
                      <small class="text-primary">{{ item.formulation_code }}</small><template v-if="item_idx < data[indextr].items.length - 1">, </template>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].items">
                    <span v-if="data[indextr].items.length > 0" v-for="(item, item_idx) in data[indextr].items" :key="item.formulation_code + '_name'">
                      <small>{{ item.formulation_name }}</small><template v-if="item_idx < data[indextr].items.length - 1">, </template>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].start_timestamp">
                    {{__dateTimeFormatter(data[indextr].start_timestamp)}}
                  </vs-td>

                  <vs-td :data="data[indextr].expiry_timestamp">
                    {{__dateTimeFormatter(data[indextr].expiry_timestamp)}}
                  </vs-td>

                  <vs-td class="font-semibold" :data="data[indextr].contract_product_code">
                    {{ data[indextr].contract_product_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].note">
                    {{ data[indextr].note}}
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip style="border-radius: 0" size="small" transparent :color="productContractsColorFactory(data[indextr].status.id)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td v-can="'create-edit-product-contract'">
                    <div class="vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button class="mr-2" @click.native="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="data[indextr].status.id === 1 || data[indextr].status.id === 2" class="mr-2" text="Cancel" position="left">
                        <vs-button @click.native="onClickStatusChangeConfirm(data[indextr].id, 'cancel')"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>


                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-full">
                      <div class="con-btns-user flex items-center justify-between">
                        <div class="con-userx flex items-center justify-start">
                        </div>
                        <div class="flex mb-4">
                        </div>
                      </div>

                      <div class="vx-row mb-1 px-24">
                        <div class="vx-col md:w-full w-full md:mb-0">
                          <h5 class="mb-2">Items</h5>
                          <vs-table stripe :data="tr.items">

                            <template slot="thead">
                              <vs-th>FINISHED PRODUCT CODE</vs-th>
                              <vs-th>PRODUCT NAME</vs-th>
                              <vs-th>INCOTERM</vs-th>
                              <vs-th>CONTRACT QUANTITY ORDERED (KG)</vs-th>
                              <vs-th>CONTRACT QUANTITY (KG)</vs-th>
                              <vs-th>CONTRACT QUANTITY BALANCE (KG)</vs-th>
                            </template>

                            <template slot-scope="{data}">
                              <vs-tr :key="indextr" v-for="(tr_item, indextr) in data">

                                <vs-td :data="data[indextr].formulation_code">
                                  <hyper-link :id="data[indextr].id" type="formulation">{{ data[indextr].formulation_code }}</hyper-link>
                                </vs-td>

                                <vs-td :data="data[indextr].formulation_name">
                                  {{ data[indextr].formulation_name }}
                                </vs-td>

                                <vs-td :data="data[indextr].incoterm">
                                  {{ data[indextr].incoterm || 'N/A'}}
                                </vs-td>

                                <vs-td :data="data[indextr].contract_quantity_ordered">
                                  {{ data[indextr].contract_quantity_ordered }}
                                </vs-td>

                                <vs-td :data="data[indextr].contract_quantity">
                                  {{ data[indextr].contract_quantity }}
                                </vs-td>

                                <vs-td :data="data[indextr].contracted_quantity_balance">
                                  {{ data[indextr].contracted_quantity_balance }}
                                </vs-td>

                                <template class="expand-user" slot="expand">
                                  <div class="con-expand-users w-full">

                                    <div class="vx-row mb-1 px-24">
                                      <div class="vx-col md:w-full w-full md:mb-0">
                                        <h5 class="mb-2">Price tiers</h5>
                                        <vs-table stripe :data="tr_item.tiers">

                                          <template slot="thead">
                                            <vs-th>MIN ORDER QTY (KG)</vs-th>
                                            <vs-th>MAX ORDER QTY (KG)</vs-th>
                                            <vs-th>PRICE ({{account_currency}}/KG)</vs-th>
                                          </template>

                                          <template slot-scope="{data}">
                                            <vs-tr :key="index_tier" v-for="(tr_tier, index_tier) in data">

                                              <vs-td :data="tr_tier.from">
                                                {{ tr_tier.from }}
                                              </vs-td>

                                              <vs-td :data="tr_tier.to">
                                                {{ tr_tier.to}}
                                              </vs-td>

                                              <vs-td :data="tr_tier.price">
                                                {{ tr_tier.price }}
                                              </vs-td>

                                            </vs-tr>
                                          </template>

                                        </vs-table>
                                      </div>
                                    </div>

                                    <div class="vx-row mb-1 px-24 mt-4">
                                      <div class="vx-col md:w-full w-full md:mb-0">
                                        <h5 class="mb-2">Related Sales Orders</h5>
                                        <div v-if="!tr_item.related_sales_orders || tr_item.related_sales_orders.length === 0" class="text-grey text-sm">No related sales orders.</div>
                                        <vs-table v-else stripe :data="tr_item.related_sales_orders">
                                          <template slot="thead">
                                            <vs-th>PRODUCT ORDER CODE</vs-th>
                                            <vs-th>ORDERED QUANTITY (KG)</vs-th>
                                          </template>
                                          <template slot-scope="{data}">
                                            <vs-tr :key="index_so" v-for="(tr_so, index_so) in data">
                                              <vs-td><hyper-link :id="tr_so.product_order_id ? tr_so.product_order_id : null" type="product-order">{{ tr_so.product_order_code }}</hyper-link></vs-td>
                                              <vs-td>{{ tr_so.ordered_quantity }}</vs-td>
                                            </vs-tr>
                                          </template>
                                        </vs-table>
                                      </div>
                                    </div>

                                  </div>
                                </template>

                              </vs-tr>
                            </template>

                          </vs-table>
                        </div>
                      </div>

                    </div>
                  </template>

                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination v-can="'view-product-contract'" :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-product-contracts-pop-up v-bind:account_currency="account_currency" ref="createCustomerProductContractsPopUp"/>
    <update-customer-product-contracts-pop-up v-bind:account_currency="account_currency" ref="updateCustomerProductContractsPopUp" />
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import CreateCustomerProductContractsPopUp from '@/components/popups/customer/product-contracts/CreateCustomerProductContractsPopUp'
  import UpdateCustomerProductContractsPopUp from '@/components/popups/customer/product-contracts/UpdateCustomerProductContractsPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import HyperLink from '@/components/Hyperlink/HyperLink'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: ''
      }
    },
    props: {
      account_currency  : {type: String,  default: ''}
    },
    components: {
      'v-select': vSelect,
      CreateCustomerProductContractsPopUp,
      UpdateCustomerProductContractsPopUp,
      HyperLink
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
      const editId = this.$route.query.edit_id
      if (editId) {
        await new Promise(resolve => this.$router.replace({ query: {} }, resolve, resolve))
        await this.$refs.updateCustomerProductContractsPopUp.openPopup(this.customerId, editId)
      }
    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },

      async loadStaff() {
        await this.$vs.loading({
          container: `#product_contract_table`,
          scale: 0.45
        })
        const {data} = await CustomerRepository.getListOfProductContracts(this.customerId, this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close(`#product_contract_table > .con-vs-loading`)
      },

      async onClickCreateSite () {
        await this.$refs.createCustomerProductContractsPopUp.openPopup(this.customerId)
      },
      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerProductContractsPopUp.openPopup(this.customerId, id)
      },

      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }
      },
      productContractsColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return 'danger';
        }
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
      onClickStatusChangeConfirm(id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeProductContractedStatus,
          parameters: [id, status]
        })
      },
      async onChangeProductContractedStatus(params){
        this.$vs.loading()
        try {
          await CustomerRepository.statusChangeCustomerProductContracted(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.loadStaff()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickDownloadSheet() {
        await this.$vs.loading({
          container: '#contract-pricing-download-button',
          scale: 0.45
        })
        try {
          const response = await CustomerRepository.downloadContractSheet(this.customerId)
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `Customer Contract Pricing List.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        } catch (e) {

        }
        this.$vs.loading.close('#contract-pricing-download-button > .con-vs-loading')
      }

    },
    watch : {
      page(){
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
